module.exports = __webpack_public_path__ + "img/product-icon_2.5fe5331a.png";